/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Product_Stock_Section_TitleInputs */

const vi_product_stock_section_title = /** @type {(inputs: Product_Stock_Section_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tồn kho`)
};

/**

* @param {Product_Stock_Section_TitleInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const product_stock_section_title = /** @type {((inputs?: Product_Stock_Section_TitleInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Product_Stock_Section_TitleInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_product_stock_section_title(inputs)
});